import { buildCancellationPolicies, buildPartiallyRefundableCancellationPolicies } from '@luxuryescapes/lib-refunds'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { toBedbankCancellationPolicy } from 'lib/offer/cancellationPolicyUtils'

export type BedbankCancellationPolicyWithInfo = { cancellationPolicy: App.BedbankCancellationPolicy, refundable: boolean, partiallyRefundable: boolean }
export function buildBedbankCancellationPolicy(cancellationPolicyInfo?: App.OfferListMetaData['cancellationPolicyInfo'], filters?: App.OfferListFilters, timezone?: string): BedbankCancellationPolicyWithInfo | undefined {
  if (!filters?.checkIn || !filters?.checkOut || !cancellationPolicyInfo || !timezone) {
    return undefined
  }
  const locale = getCurrentIntl().locale

  if (cancellationPolicyInfo.partiallyRefundable) {
    return {
      cancellationPolicy: toBedbankCancellationPolicy(buildPartiallyRefundableCancellationPolicies(
        {
          checkIn: filters.checkIn,
          checkOut: filters.checkOut,
          policies: cancellationPolicyInfo.cancellationPolicies,
          nonRefundableDates: cancellationPolicyInfo.nonRefundableDateRanges,
        },
        {
          timezone,
          locale,
          midnightWrap: false,
        } as any,
      )),
      refundable: false,
      partiallyRefundable: true,
    }
  } else {
    return {
      cancellationPolicy: toBedbankCancellationPolicy(buildCancellationPolicies(cancellationPolicyInfo.cancellationPolicies, { timezone, locale, midnightWrap: false } as any)),
      refundable: cancellationPolicyInfo.refundable,
      partiallyRefundable: cancellationPolicyInfo.partiallyRefundable,
    }
  }
}
